import { ReactElement } from "react";
import LogoImage from "../../../Assets/logo-blue.png";
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../messages/en-US";

interface Props {
  /** Height/layout classes for the wrapper. Defaults to full page; pass e.g. "h-full" to fill a container. */
  className?: string;
}

export default function LoadingSpinner({ className }: Props): ReactElement {
  const localizationService = useLocalization();
  return (
    <div
      className={`flex flex-col items-center justify-center gap-6 ${
        className ?? "h-[calc(100vh-68px)]"
      }`}
    >
      {/* Logo centered inside the spinning ring (self-contained, no ancestor positioning) */}
      <div className="relative flex h-32 w-32 items-center justify-center">
        <div className="absolute inset-0 animate-spin rounded-full border-b-2 border-primary-400" />
        <img src={LogoImage} className="h-20 w-20" alt="Loading Spinner" />
      </div>
      <div>{localizationService.toLanguageString('custom.loading', enMessages.custom.loading)}</div>
    </div>
  );
}
